import { cn } from '../../utils/cn';

/**
 * Unified Button System
 * 
 * Consistent button styling across the app.
 * 
 * @param {string} variant - Button style: 'primary' | 'secondary' | 'ghost'
 * @param {string} size - Size: 'sm' | 'md' | 'lg'
 * @param {string} className - Additional classes
 * 
 * Usage:
 * <Button>Primary Button</Button>
 * <Button variant="secondary">Secondary</Button>
 * <Button variant="ghost" size="sm">Ghost</Button>
 */
export function Button({ 
  children, 
  variant = 'primary',
  size = 'md',
  className = '',
  disabled = false,
  ...props 
}) {
  const sizeClasses = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg',
  };

  const variantClasses = {
    primary: 'bg-primary text-white hover:bg-primary-dark shadow-button hover:shadow-button-hover disabled:opacity-50 disabled:cursor-not-allowed',
    secondary: 'bg-white text-text-primary border border-border hover:bg-surface disabled:opacity-50 disabled:cursor-not-allowed',
    ghost: 'bg-transparent text-primary hover:bg-primary/10 disabled:opacity-50 disabled:cursor-not-allowed',
  };

  return (
    <button
      className={cn(
        'font-semibold rounded-lg transition-all duration-200',
        sizeClasses[size],
        variantClasses[variant],
        className
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
